import type { VideoCarouselType } from "@fdr/program-page/src/types";
import {
  HandicapSortOptionsType,
  RaceProgram,
  RaceWagerType
} from "@tvg/ts-types/Race";

type SetCurrentRaceAction = { type: "SET_CURRENT_RACE"; payload: RaceProgram };

type SetTrackRacesAction = { type: "SET_TRACK_RACES"; payload: RaceProgram[] };

type SetPreviousPath = { type: "SET_PREVIOUS_PATH"; payload: string };

type SetHasMultiLegWagerAction = {
  type: "SET_HAS_MULTI_LEG_WAGERS";
  payload: boolean;
};

type SetVideoCarouselAction = {
  type: "SET_VIDEO_CAROUSEL";
  payload: VideoCarouselType;
};

type ShowRaceNavigationHeaderAction = {
  type: "SHOW_HEADER_NAVIGATION";
  payload: boolean;
};

type SetSelectionRequestAction = {
  type: "SET_BET_SELECTIONS";
  payload: string[][];
};

type UserSetHandicappingSortModeAction = {
  type: "USER_SET_HANDICAPPING_SORT_MODE";
  payload?: HandicapSortOptionsType;
};

type SetWagerType = { type: "SET_WAGER_TYPE"; payload: RaceWagerType };

type SetUpdatePicksAction = { type: "SHOULD_UPDATE_PICKS"; payload: boolean };

type SetLoadingRunners = { type: "SET_LOADING_RUNNERS"; payload: boolean };

type SetOpenAllRunners = { type: "SET_OPEN_ALL_RUNNERS"; payload: boolean[] };

type SetRunnerSelections = {
  type: "SET_SELECTED_RUNNERS";
  payload: string[][];
};

export type Actions =
  | ShowRaceNavigationHeaderAction
  | SetCurrentRaceAction
  | SetTrackRacesAction
  | SetPreviousPath
  | SetWagerType
  | SetSelectionRequestAction
  | UserSetHandicappingSortModeAction
  | SetUpdatePicksAction
  | SetLoadingRunners
  | SetOpenAllRunners
  | SetRunnerSelections
  | SetHasMultiLegWagerAction
  | SetVideoCarouselAction;

export const showRaceNavigationHeader = (
  value: boolean
): ShowRaceNavigationHeaderAction => ({
  type: "SHOW_HEADER_NAVIGATION",
  payload: value
});

export const setRace = (race: RaceProgram): SetCurrentRaceAction => ({
  type: "SET_CURRENT_RACE",
  payload: race
});

export const setTrackRaces = (races: RaceProgram[]): SetTrackRacesAction => ({
  type: "SET_TRACK_RACES",
  payload: races
});

export const setPreviousPath = (prevPath: string): SetPreviousPath => ({
  type: "SET_PREVIOUS_PATH",
  payload: prevPath
});

export const setWagerType = (wagerType: RaceWagerType): SetWagerType => ({
  type: "SET_WAGER_TYPE",
  payload: wagerType
});

export const setSelectionRequest = (
  selections: string[][]
): SetSelectionRequestAction => ({
  type: "SET_BET_SELECTIONS",
  payload: selections
});

export const userSetHandicappingSortModeAction = (
  value?: HandicapSortOptionsType
): UserSetHandicappingSortModeAction => ({
  type: "USER_SET_HANDICAPPING_SORT_MODE",
  payload: value
});

export const shouldUpdatePicks = (value: boolean): SetUpdatePicksAction => ({
  type: "SHOULD_UPDATE_PICKS",
  payload: value
});

export const setLoadingRunners = (value: boolean): SetLoadingRunners => ({
  type: "SET_LOADING_RUNNERS",
  payload: value
});

export const setOpenAllRunners = (value: boolean[]): SetOpenAllRunners => ({
  type: "SET_OPEN_ALL_RUNNERS",
  payload: value
});

export const setHasMultiLegWagersAction = (
  value: boolean
): SetHasMultiLegWagerAction => ({
  type: "SET_HAS_MULTI_LEG_WAGERS",
  payload: value
});

export const setVideoCarouselAction = (
  value: VideoCarouselType
): SetVideoCarouselAction => ({
  type: "SET_VIDEO_CAROUSEL",
  payload: value
});

export const setSelectedRunners = (
  selections: string[][]
): SetRunnerSelections => ({
  type: "SET_SELECTED_RUNNERS",
  payload: selections
});
